document.addEventListener('DOMContentLoaded', function () {
  infiniteScroll();
});
function infiniteScroll() {
  const endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#Huratips-Pagination',
    method: 'scroll',
    callback: function () {
      hideDuplicatePromos();
      if (typeof Shopify !== 'undefined' && typeof Shopify.cardProductSlider === 'function') {
        Shopify.cardProductSlider('#product-grid .prod-images-slider');
      } else {
        handleSwiper();
      }
    }
  });
}
function hideDuplicatePromos() {
  const seenPromos = {
    promo_coloum1: false,
    promo_coloum2: false,
    promo_coloum3: false
  };
  document.querySelectorAll('.promotional-block-main').forEach(function (element) {
    const promoClass = element.className.split(' ').find((cls) => seenPromos.hasOwnProperty(cls));
    if (promoClass) {
      if (seenPromos[promoClass]) {
        element.classList.add('hide');
      } else {
        seenPromos[promoClass] = true;
      }
    }
  });
}

document.addEventListener('click', function (e) {
  const option = e.target.closest('.cust_sortby .sort-option');
  if (!option) return;
  document.querySelectorAll('.cust_sortby .sort-option').forEach(function (opt) {
    opt.classList.remove('active');
  });
  option.classList.add('active');
  const sortInput = document.getElementById('SortBy-mobile');
  if (sortInput) {
    sortInput.value = option.getAttribute('value');
    if (typeof Shopify.queryParams !== 'object' || Shopify.queryParams === null) {
      Shopify.queryParams = {};
    }
    Shopify.queryParams.sort_by = sortInput.value;
    updateProductListing(Shopify.queryParams);
  }
});

function updateProductListing(params) {
  const url = new URL(window.location.href);
  Object.keys(params).forEach((key) => url.searchParams.set(key, params[key]));
  history.replaceState(null, '', url);
  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const productGrid = document.getElementById('product-grid');
      productGrid.querySelectorAll('.prod-images-slider').forEach((container) => {
        if (container.swiper) {
          container.swiper.destroy(true, true);
          container.swiper = null;
        }
      });
      productGrid.innerHTML = doc.getElementById('product-grid').innerHTML;
      Shopify.cardProductSlider('.prod-images-slider');
      if (doc.getElementById('Huratips-Pagination')) {
        document.getElementById('Huratips-Pagination').innerHTML = doc.getElementById('Huratips-Pagination').innerHTML;
      }
    })
    .catch((error) => console.error('Error fetching the sorted content:', error));
}
document.addEventListener('DOMContentLoaded', () => {
  const description = document.querySelector('.mobile_sort_description');
  const readMore = document.querySelector('.readmore');
  if (!description || !readMore) return;
  if (description.scrollHeight > description.clientHeight) {
    readMore.style.visibility = 'visible';
  }
});
